
<template>
  <v-app id="mergeKlntList">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Merge guest List</v-card-title>
      <v-simple-table dense>
        <thead>
           <tr>
             <th>Id</th>
             <th>Email</th>
             <th>Id</th>
             <th>Email</th>
           </tr>  
         </thead>
         <tbody v-for="(klntRecord,i) in mergeKlntList" :key="i">
           <tr>
            <td @click="$router.open('/klnt/onKlnt/' + klntRecord.klnt1_encrid)"> {{klntRecord.klnt1_code}}</td>
            <td @click="$router.open('/klnt/onKlnt/' + klntRecord.klnt1_encrid)">{{klntRecord.klnt1_email}}</td>
            <td @click="$router.open('/klnt/onKlnt/' + klntRecord.klnt2_encrid)"> {{klntRecord.klnt2_code}}</td> 
            <td @click="$router.open('/klnt/onKlnt/' + klntRecord.klnt2_encrid)">{{klntRecord.klnt2_email}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Various" :home="true" type="various" />    
  </v-app>
</template>


<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    export default {
        components: {
            navBar,
        },
        data() {
            return {
                mergeKlntList: []
            }  
        },
    mounted() {
            this.$axios
                .post("ares/json/ares/task/various/klnt/mergeKlntList.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "mergeKlntList"
                    },
                        mergeKlntList: {
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.mergeKlntList = res.data.mergeKlntList;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    };

</script> 
